import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "engine/store";

interface ProtectedRouteProps {
  children: ReactElement;
  condition: (user: any) => boolean;
  redirectTo?: string;
}

export const ProtectedRoute = ({ children, condition, redirectTo = "/dashboard" }: ProtectedRouteProps) => {
  const user = useAppSelector((state) => state.auth.user);

  if (!user || !condition(user)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

